"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetailsContact = _interopRequireDefault(require("../../styles/dealer-details-contact.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var DealerEmail = function DealerEmail(_ref) {
  var email = _ref.email,
    theme = _ref.theme,
    clickHandler = _ref.clickHandler;
  if (!(0, _checkProps["default"])(email)) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: _dealerDetailsContact["default"].dealerDetailLink + " " + (theme ? theme.textLinkPrimary : '') + " " + (theme ? theme.smallType : ''),
      href: "mailto:" + email + " ",
      onClick: function onClick() {
        return clickHandler && clickHandler(email);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cpath fill='%23000' id='a' d='M2 20h20V4H2v16zM5.667 6h12.666L12 10.75 5.667 6zM20 7.25V18H4V7.25l8 6 8-6z'/%3E%3C/defs%3E%3Cuse fill-rule='evenodd' xlink:href='%23a'/%3E%3C/svg%3E",
      alt: "email icon",
      className: _dealerDetailsContact["default"].contactIcon
    }), email);
  }
};
var _default = DealerEmail;
exports["default"] = _default;